import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="page page--not-found">
      <h1 className="not-found__title">This page doesn't exist.</h1>
      <p className="not-found__body">
        The URL you followed isn't part of Sacristy.
      </p>
      <Link to="/" className="not-found__link">
        Back to dashboard&nbsp;→
      </Link>
    </main>
  );
}
